import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import hogarImage from '../assets/casita.jpg';
import '../styles/disenosegurosbase.css';

export default function SeguroDelHogar() {
  const navigate = useNavigate();
  
  // ===== ESTADOS =====
  const [formData, setFormData] = useState({
    nombre: "",
    edad: "",
    genero: "",
    codigoPostal: "",
    ingresos: "",
    ciudad: "",
    correo: "",
    numero: ""
  });

  // ===== FUNCIONES =====
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    const { nombre, edad, genero, codigoPostal, ingresos, ciudad, correo, numero } = formData;

    // Validar campos vacíos
    if (!nombre || !edad || !genero || !codigoPostal || !ingresos || !ciudad || !correo || !numero) {
      Swal.fire('Campos incompletos', 'Por favor llena todos los campos obligatorios.', 'warning');
      return false;
    }

    // Validar edad
    if (isNaN(edad) || edad <= 0 || edad > 99) {
      Swal.fire('Error', 'Por favor ingresa una edad válida entre 1 y 99 años.', 'error');
      return false;
    }

    // Validar ingresos
    if (isNaN(ingresos) || ingresos <= 0) {
      Swal.fire('Error', 'El ingreso debe ser un número válido.', 'error');
      return false;
    }

    // Validar código postal
    if (isNaN(codigoPostal) || codigoPostal.toString().length !== 5) {
      Swal.fire('Error', 'El código postal debe tener 5 dígitos.', 'error');
      return false;
    }

    // Validar correo
    const correoValido = /^[a-zA-Z0-9._%+-]+@(gmail|hotmail|outlook|yahoo)\.com$/;
    if (!correoValido.test(correo)) {
      Swal.fire('Error', 'Por favor, ingresa un correo válido de @gmail.com, @hotmail.com, @outlook.com o @yahoo.com.', 'error');
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      const response = await fetch(`https://ricardodiaztuasesorfinanciero.com/api/citasegurohogar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Nombre: formData.nombre,
          Edad: formData.edad,
          Genero: formData.genero,
          CodigoPostal: formData.codigoPostal,
          Ingresos: formData.ingresos,
          Ciudad: formData.ciudad,
          Correo: formData.correo,
          Numero: formData.numero
        }),
      });

      const result = await response.json();
      console.log(result);
      
      Swal.fire({
        title: "¡Gracias! Nos pondremos en contacto pronto!",
        icon: "success",
        draggable: true
      });
    } catch (error) {
      console.error("Error al enviar los datos", error);
      Swal.fire('Error', 'Ocurrió un error al enviar los datos.', 'error');
    }
  };

  // ===== RENDERIZADO =====
  return (
    <>
      {/* Botón de regreso */}
      <button
        onClick={() => navigate('/')}
        className="seguro-back"
      >
        ← Regresar al Menú
      </button>

      <div className="seguro-container">
        {/* Sección izquierda con imagen */}
        <div className="seguro-left">
          <img src={hogarImage} alt="Hogar" />
          <div className="seguro-overlay">
            <h1>Protege tu hogar hoy</h1>
            <p>
              Completa el formulario y obtén una cotización para asegurar lo que más importa.
            </p>
          </div>
        </div>

        {/* Formulario */}
        <div className="seguro-form">
          <h2>Cotización Seguro del Hogar</h2>

          <label>Nombre:</label>
          <input 
            type="text" 
            name="nombre"
            value={formData.nombre} 
            onChange={handleInputChange} 
          />

          <label>Edad:</label>
          <input 
            type="number" 
            name="edad"
            value={formData.edad} 
            onChange={handleInputChange} 
          />

          <label>Género:</label>
          <select 
            name="genero"
            value={formData.genero} 
            onChange={handleInputChange}
          >
            <option value="">Selecciona</option>
            <option value="Masculino">Masculino</option>
            <option value="Femenino">Femenino</option>
          </select>

          <label>Código Postal:</label>
          <input 
            type="number" 
            name="codigoPostal"
            value={formData.codigoPostal} 
            onChange={handleInputChange} 
          />

          <label>Ciudad:</label>
          <input 
            type="text" 
            name="ciudad"
            value={formData.ciudad} 
            onChange={handleInputChange} 
          />

          <label>Ingresos mensuales (aproximado):</label>
          <select 
            name="ingresos"
            value={formData.ingresos} 
            onChange={handleInputChange}
          >
            <option value="">Selecciona tu rango de ingresos</option>
            <option value="10,000 - 20,000">$10,000 - $20,000</option>
            <option value="20,000 - 30,000">$20,000 - $30,000</option>
            <option value="30,000 - 40,000">$30,000 - $40,000</option>
            <option value="40,000 - 50,000">$40,000 - $50,000</option>
            <option value="Más de 50,000">Más de $50,000</option>
          </select>

          <label>Correo:</label>
          <input 
            type="email" 
            name="correo"
            value={formData.correo} 
            onChange={handleInputChange} 
          />

          <label>Teléfono:</label>
          <input 
            type="tel" 
            name="numero"
            value={formData.numero} 
            onChange={handleInputChange} 
          />

          <button onClick={handleSubmit} className="seguro-btn">
            Enviar
          </button>

          <p
            onClick={() => navigate("/pantallaCIT")}
            className="seguro-link"
          >
            ¿Quieres atención más directa? Agenda tu cita aquí!
          </p>
        </div>
      </div>
    </>
  );
}